<template>
    <div class="consult-container">
        <ComDetail :detail="detail" :detailCols="detailCols" :onCancel="onCancel"></ComDetail>
        <div class="search-container">
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item label="用户名称">
                    <el-input v-model="formInline.userName" placeholder="请输入用户名称"></el-input>
                </el-form-item>
                <el-form-item label="应用名称">
                    <el-input v-model="formInline.appName" placeholder="请输入应用名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-container">
            <el-table v-loading="tableLoading" :data="tableData" :pagination="pagination" border style="width: 100%">
                <el-table-column prop="userName" label="用户名称" align="center">
                </el-table-column>
                <el-table-column prop="evaluateDate" label="评价时间" align="center" :formatter="dateFormat">
                </el-table-column>
                <el-table-column prop="appName" align="center" label="应用名称">
                </el-table-column>
                <el-table-column prop="serverName" align="center" label="供应商">
                </el-table-column>
                <el-table-column prop="content" align="center" label="评价内容">
                </el-table-column>
                <el-table-column label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
                        <el-popconfirm title="确定要删除吗？" @confirm="handleDelete(scope.row)">
                            <el-button slot="reference" class="ml-10" type="text" size="small">删除</el-button>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="pagination.currentPage" :page-sizes="[10, 20, 30, 40]"
                    :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="pagination.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { getAppEvalautionList, getAppEvalautionDel } from '@/api/SupermarketOperation'
import moment from "moment";
import ComDetail from '@/components/common/comDetail.vue';
export default {
    name: 'AdminStaticsUserEvaluation',
    components: {
        ComDetail
    },
    data() {
        return {
            tableLoading: false,
            detail: {
                visible: false,
                record: {},
            },
            detailCols: [
                {
                    label: '用户名称',
                    prop: 'userName'
                },
                {
                    label: '评价时间',
                    prop: 'evaluateDate',
                    formatter: (row) => moment(row.evaluateDate).format('YYYY-MM-DD HH:mm:ss'),
                },
                {
                    label: '应用名称',
                    prop: 'appName'
                },
                {
                    label: '供应商',
                    prop: 'serverName'
                },
                {
                    label: '评价内容',
                    prop: 'content'
                },
            ],
            formInline: {
                userName: '',
                appName: '',
            },
            pagination: {
                currentPage: 1, // 当前页
                pageSize: 10, // 每页显示条数
                total: 0, // 总条数
                layout: 'total, prev, pager, next, jumper', // 分页布局
            },
            tableData: [],
        };
    },

    mounted() {
        this.loadData()
    },
    methods: {
        // 查看
        onCancel() {
            this.detail.visible = false
        },
        // 删除
        handleDelete(row) {
            getAppEvalautionDel({
                id: row.id
            }).then(() => {
                this.$message.success('删除成功')
                this.loadData()
            })
        },
        // 时间转换
        dateFormat(row) {
            return moment(row.evaluateDate).format('YYYY-MM-DD HH:mm:ss');
        },
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.loadData()
        },
        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.loadData()
        },
        handleClick(row) {
            this.detail.visible = true
            this.detail.record = row
        },
        onSubmit() {
            this.loadData()
        },
        async loadData() {
            this.tableLoading = true
            const params = {}
            if (this.formInline.userName) {
                params.userName = this.formInline.userName
            }
            if (this.formInline.appName) {
                params.appName = this.formInline.appName
            }
            await getAppEvalautionList({
                type: 1,
                pageNo: this.pagination.currentPage - 1,
                pageSize: this.pagination.pageSize,
                ...params,
            }).then(res => {
                this.tableLoading = false
                this.tableData = res.data.content
                this.pagination.total = res.data.totalElements
            })
        }
    },
};
</script>
<style lang="scss" scoped>
.consult-container {
    background: #fff;
    padding: 24px 0;

    .search-container {
        padding: 0 16px;
        border-bottom: 1px solid #EBEEF5;
    }

    .table-container {
        padding: 16px;
    }

    .pagination-container {
        margin-top: 16px;
        text-align: right;
    }

    .ml-10 {
        margin-left: 10px;
    }
}
</style>
<style lang="scss">
.el-popconfirm__main {
    margin: 10px 0;
}
</style>